














import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { booleanFormatter, isNullOrEmpty } from '../utils';

@Component({
    components: {}
})
export default class CustomSwitch extends Vue {
    @Prop({default: ''}) label: string;
    @Prop({default: null}) value: boolean;
    boolFormat: Function = booleanFormatter;

    @Emit()
    changeValue(){}
   

}
